module.exports = __webpack_public_path__ + "img/screenshot-device-dashboard-sync.0663cbad.jpg";